import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

export default function TournamentColumnBox(props) {
  const { value, setValue, placeholder, isModify } = props;
 
  const [width, setWidth] = useState(92);

  const SpanRef = useRef();

  // 인풋 크기 정리
  useEffect(() => {
    if (SpanRef.current) setWidth(SpanRef.current.offsetWidth + 4);
  }, [value])

  // Input 데이터 변경시 //
  function onChange(e) {
    setValue(e.target.value);
  }

  return (
    <ColumnBox>
      <HiddenSpan ref={SpanRef}>{value || placeholder}</HiddenSpan>
      <Input 
        value={value}
        onChange={onChange}
        type='text'
        width={width}
        disabled={!isModify}
        placeholder={placeholder}/>
    </ColumnBox>
  );
}

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  min-width: 92px;
  height: 40px;

  border-radius: 8px;
  background-color: #6DD49E;

  :hover {
    cursor: pointer;
  }

  // transition: all 0.3s ease-in-out;
`;

const HiddenSpan = styled.span`
  position: absolute;

  visibility: hidden;
  white-space: pre;

  font-family: NotoSansKR-Bold;
  font-size: 14px;
  line-height: 18px;

  padding: 0;
  margin: 0;
`;

const Input = styled.input`
	font-family: NotoSansKR-Bold;
	font-size: 14px;
	line-height: 18px;

	// width: 100%;
  width: ${props => props.width}px;
	height: 18px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
  text-align: center;
	color: #FFFFFF;

  border: none;
  background-color: #6DD49E;

	::placeholder {
		color: #FFFFFF;
	}
  
  // transition: all 0.3s ease-in-out;
`;